export const envVars = {
  appName: 'simulation',
  release: process.env.COMMIT_RELEASE,
  environment: process.env.name,
  BFF_URI: process.env.BFF_URI,
  DATADOG_APPLICATION_ID: process.env.DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN,
}
